import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const GalleryView = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M11 3H3.5V9.5C3.5 10.0523 3.94772 10.5 4.5 10.5L10 10.5C10.5523 10.5 11 10.0523 11 9.5V3Z"
          fill="#2D425B"
          fillOpacity="0.05"
        />
        <path
          d="M21.5 3H14V9.5C14 10.0523 14.4477 10.5 15 10.5L20.5 10.5C21.0523 10.5 21.5 10.0523 21.5 9.5V3Z"
          fill="#2D425B"
          fillOpacity="0.05"
        />
        <path
          d="M11 13.5H3.5V20C3.5 20.5523 3.94772 21 4.5 21L10 21C10.5523 21 11 20.5523 11 20V13.5Z"
          fill="#2D425B"
          fillOpacity="0.05"
        />
        <path
          d="M21.5 13.5H14V20C14 20.5523 14.4477 21 15 21L20.5 21C21.0523 21 21.5 20.5523 21.5 20V13.5Z"
          fill="#2D425B"
          fillOpacity="0.05"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.47369 2.97369C3.92141 2.97369 3.47369 3.42141 3.47369 3.97369V10.079C3.47369 10.6312 3.92141 11.079 4.47369 11.079H10.579C11.1312 11.079 11.579 10.6312 11.579 10.079V3.97369C11.579 3.42141 11.1312 2.97369 10.579 2.97369H4.47369ZM4.47369 3.97369L10.579 3.97369V10.079L4.47369 10.079V3.97369ZM4.47369 12.9211C3.92141 12.9211 3.47369 13.3688 3.47369 13.9211V20.0263C3.47369 20.5786 3.92141 21.0263 4.47369 21.0263H10.579C11.1312 21.0263 11.579 20.5786 11.579 20.0263V13.9211C11.579 13.3688 11.1312 12.9211 10.579 12.9211H4.47369ZM4.47369 13.9211H10.579V20.0263L4.47369 20.0263V13.9211ZM13.4211 3.97369C13.4211 3.42141 13.8688 2.97369 14.4211 2.97369H20.5263C21.0786 2.97369 21.5263 3.42141 21.5263 3.97369V10.079C21.5263 10.6312 21.0786 11.079 20.5263 11.079H14.4211C13.8688 11.079 13.4211 10.6312 13.4211 10.079V3.97369ZM20.5263 3.97369L14.4211 3.97369V10.079L20.5263 10.079V3.97369ZM14.4211 12.9211C13.8688 12.9211 13.4211 13.3688 13.4211 13.9211V20.0263C13.4211 20.5786 13.8688 21.0263 14.4211 21.0263H20.5263C21.0786 21.0263 21.5263 20.5786 21.5263 20.0263V13.9211C21.5263 13.3688 21.0786 12.9211 20.5263 12.9211H14.4211ZM14.4211 13.9211H20.5263V20.0263L14.4211 20.0263V13.9211Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default GalleryView
